import {combineReducers} from "redux";
import invite from './invite';
import list from './list';
import del from './delete'
import update from './update'

export default combineReducers({list, invite, update, del});
